import { Modal, message } from 'ant-design-vue';
import axios, { AxiosRequestConfig } from 'axios';
import commonStore from '@/store/common';
import useUserHooks from '@/hooks/user.hooks';

const { CancelToken } = axios;
const source = CancelToken.source();
const userHooks = useUserHooks();
let timeoutModalVisible = false;
let networkErrorModalVisible = false;
export const baseURL = process.env.NODE_ENV === 'development'
  ? '/'
  // ? 'http://192.168.1.188:8082/hero/'
  : window.location.origin + window.location.pathname;
const http = axios.create({
  baseURL,
  // baseURL: '',
  timeout: 8000,
  headers: {},
});

// 是否携带cookie
http.defaults.withCredentials = false;
// if (sessionStorage.getItem('token')) {
//   http.defaults.headers.common.token = sessionStorage.token;
// }

if (commonStore.getState().token) {
  http.defaults.headers.common.token = commonStore.getState().token;
}
if (userHooks.getUserInfo().token) {
  http.defaults.headers.common.token = userHooks.getUserInfo().token;
}

http.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const { token } = commonStore.getState();
    if (token) config.headers.common.token = token;
    if (userHooks.getUserInfo().token) config.headers.common.token = userHooks.getUserInfo().token;
    return config;
  },
  (error) => Promise.reject(error),
);
// 添加响应拦截器
http.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    response.config.cancelToken = source.token;
    if (response.data.success) {
      return response;
    }
    if (response.data.success === undefined) {
      // 修复部分接口不符合返回格式规范，导致无法获取response
      return response;
    }

    if (response.data.tokenValidateError) {
      source.cancel(response.data.message);
      Modal.error({
        title: '错误',
        content: response.data.message,
        onOk() {
          sessionStorage.clear();
          window.location.href = '/hero';
        },
      });
    } else if (!response.data.success) {
      // 提示一下 接口的抛错信息
      message.error(response.data.message);
      throw new Error(response.data.message);
    }
    return Promise.reject(response.data.message);
  },
  (error) => {
    // 网络错误弹窗
    if (error.message === 'Network Error' && !networkErrorModalVisible) {
      source.cancel();
      networkErrorModalVisible = true;
      Modal.info({
        title: '系统提示',
        content: '网络连接出错，请重试。',
        onOk() {
          networkErrorModalVisible = false;
          window.location.reload();
        },
      });
    }
    // 接口超时弹窗
    if (error.code === 'ECONNABORTED' && !timeoutModalVisible) {
      source.cancel();
      timeoutModalVisible = true;
      Modal.info({
        title: '系统提示',
        content: '网络连接超时，请重试。',
        onOk() {
          timeoutModalVisible = false;
          window.location.reload();
        },
      });
    }
    return Promise.reject(error);
  },
);

const mock = axios.create({
  // baseURL: '',
  timeout: 8000,
  headers: {},
});

export {
  mock,
};

export default http;
